import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"
import Prose from "../prose"

const Person = ({ name, image, contentText }) => {
  const fallbackImage =
    "//images.ctfassets.net/ksssf3t869cm/5bo5BqlSg5gpvCG4K3Qiq7/126a43d60824dcd4e77b9c7de65f6028/person.png"
  return (
    <article className="flex md:items-center">
      {image ? (
        <GatsbyImage
          className="!rounded-full overflow-hidden w-20 h-20 md:w-52 md:h-52 flex-shrink-0"
          image={image}
          alt=""
        />
      ) : (
        <div className="rounded-full overflow-hidden w-20 h-20 md:w-52 md:h-52 flex-shrink-0">
          <img src={fallbackImage} alt="" />
        </div>
      )}

      <div className="ml-4 md:ml-8">
        {name && <h3 className="text-lg lg:text-xl mb-2">{name}</h3>}
        {contentText && <Prose content={contentText} />}
      </div>
    </article>
  )
}

Person.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.object,
  contentText: PropTypes.string.isRequired,
}

export default Person
